export const constants = {
    google_pass_mail: process.env.REACT_APP_GOOGLE_PASS,
    backend_url: process.env.REACT_APP_BACKEND_URL,
    test_host: process.env.REACT_APP_TEST_HOST,
    user_id: process.env.REACT_APP_USER_ID,
    page_id: process.env.REACT_APP_PAGE_ID,
    backend_for_contact: process.env.REACT_APP_BACKEND_CONTACT,
    domain:process.env.REACT_APP_DOMAIN,
    http:process.env.REACT_APP_HTTP,
}